import { ArrowCounterClockwise } from "@phosphor-icons/react";

/** Overlay fullscreen exibido durante o processamento do restore. */
export default function RestoreProgress() {
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center pointer-events-none">
      <div className="bg-white border border-black px-8 py-6 flex items-center gap-4">
        <ArrowCounterClockwise size={32} weight="bold" className="animate-spin text-[#E60000]" />
        <div>
          <div className="font-bold text-lg">Restaurando banco de dados...</div>
          <div className="text-xs text-zinc-500 mt-1">Não feche esta janela. Isso pode levar alguns minutos.</div>
        </div>
      </div>
    </div>
  );
}
